import type { BotConfigurationFormData } from '../components/admin/BotConfigurationForm';
import type { ChatbotConciergeInput } from '@workspace/types';

const KEYWORD_MAX = 32;
const KEYWORDS_MAX = 10;

export function parseEscapeKeywords(raw: string | undefined): string[] {
  if (!raw?.trim()) {
    return [];
  }
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of raw.split(',').slice(0, KEYWORDS_MAX)) {
    const item = part.trim().slice(0, KEYWORD_MAX);
    if (!item || seen.has(item)) {
      continue;
    }
    seen.add(item);
    result.push(item);
  }
  return result;
}

export function conciergeFormToPayload(data: BotConfigurationFormData): {
  kind: 'STANDARD' | 'CONCIERGE';
  conversationMode?: 'SINGLE' | 'MULTIPLE';
  concierge?: ChatbotConciergeInput;
  menuLabel?: string | null;
  menuDescription?: string | null;
  isRoutable?: boolean;
} {
  const catalog = {
    menuLabel: data.menuLabel?.trim() ? data.menuLabel.trim().slice(0, 24) : undefined,
    menuDescription: data.menuDescription?.trim()
      ? data.menuDescription.trim().slice(0, 72)
      : undefined,
    isRoutable: data.isRoutable,
  };
  if (data.kind !== 'CONCIERGE') {
    return { kind: 'STANDARD', ...catalog };
  }
  return {
    kind: 'CONCIERGE',
    conversationMode: 'SINGLE',
    concierge: {
      webMandatory: Boolean(data.webMandatory),
      idleMinutes: data.idleMinutes ? Number.parseInt(data.idleMinutes, 10) : 30,
      pendingIdleMinutes: data.pendingIdleMinutes
        ? Number.parseInt(data.pendingIdleMinutes, 10)
        : 240,
      welcomeText: (data.welcomeText ?? '').trim().slice(0, 2000),
      escapeKeywords: parseEscapeKeywords(data.escapeKeywords),
      classifyEnabled: data.classifyEnabled ?? true,
      topicShiftEnabled: data.topicShiftEnabled ?? false,
    },
    ...catalog,
  };
}
